import { createReducer } from "utils/redux";

export const NEWS_QUERY_LIST_SUCCESS = 'NEWS_QUERY_LIST_SUCCESS';
export const NEWS_QUERY_LIST_FAILED = 'NEWS_QUERY_LIST_FAILED';

export const NewsList = createReducer(
  NEWS_QUERY_LIST_SUCCESS,
  NEWS_QUERY_LIST_FAILED
);